import { render, staticRenderFns } from "./UserShow.vue?vue&type=template&id=e4d9d024&scoped=true&"
import script from "./UserShow.vue?vue&type=script&lang=ts&"
export * from "./UserShow.vue?vue&type=script&lang=ts&"
import style0 from "./UserShow.vue?vue&type=style&index=0&id=e4d9d024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d9d024",
  null
  
)

export default component.exports